import React, {useEffect, useState} from 'react';
import styles from './index.module.less';
import image1 from './images/1.jpg';
import CourseCard from "../components/course-card";
import {Button} from "@blueprintjs/core";
import classnames from 'classnames';
import { useHistory } from 'react-router-dom';
import axios from "axios";

const MainSales = () => {
  const [status, setStatus] = useState(0);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [price, setPrice] = useState(0);
  const [rawPrice, setRawPrice] = useState(0);
  const [courseList, setCourseList] = useState([]);
  const history = useHistory();
  useEffect(() => {
    axios.get('/api/mall/wx_user_course').then((response) => {
      const { code, data } = response.data;
      if (code === 0) {
        setCourseList(data.map(course => ({
          ...course,
          itemId: course.item_id,
          subItemId: course.sub_item_id
        })))
      }
    });
  }, []);
  useEffect(() => {
    if (selectedCourses.length === 0) {
      return;
    }
    setPrice((99 - (selectedCourses.length - 1) * 10) * selectedCourses.length);
    setRawPrice(199 * selectedCourses.length);
  }, [selectedCourses]);
  const handleClickBtn = () => {
    if (status === 0) {
      setStatus(1);
      return;
    }
    axios.post('/api/mall/submit_order', {
      items: JSON.stringify(selectedCourses.map((course => {
        return {
          item_id: course.itemId,
          sub_item_id: course.subItemId,
          count: 1
        }
      }))),
      buy_from: 'test',
      pay_type: 201
    }).then((response) => {
      const { code, data, msg } = response.data;
      if (code === 0) {
        const { order_uuid, pay_request } = data;
        window.WeixinJSBridge.invoke('getBrandWCPayRequest', pay_request, (res) => {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            history.push('/sales/success/' + order_uuid);
          }
        });
      } else {
        console.log(msg);
      }
    });
  };
  const handleCloseSelector = () => {
    setStatus(0);
    setSelectedCourses([]);
  };
  const renderFooter = () => {
    // if (courseList.filter(course => course.is_buy === false).length === 0) {
    //   return null;
    // }
    return (
      <div className={styles.footer}>
        <div className={styles.info}>
          <div className={styles['selected-info']}>
            {selectedCourses.length > 0 ? `已选 ${selectedCourses.length} 门课程` : '点击卡片了解课程详情'}
          </div>
          {selectedCourses.length > 0 && (
            <div className={styles['price-info']}>
              <div className={styles.old}>
                <del>原价{rawPrice}元</del>
                <span>&nbsp;&nbsp;到手价</span>
              </div>
              <div className={styles.cur}>{price}元</div>
            </div>
          )}
        </div>
        <Button large className={styles.action} onClick={handleClickBtn}>{ status === 0 ? '超值打包购买' : '立即支付' }</Button>
      </div>
    );
  };
  return (
    <div className={styles['sales-page']}>
      <img className={styles.image} src={image1} alt=""/>
      {courseList.map(course => <CourseCard key={course.id} course={course} className={styles['course-card']} />)}
      {renderFooter()}
      { status === 1 && (
        <div className={styles.popup}>
          <div className={styles.clickable} onClick={handleCloseSelector} />
          <div className={styles.main}>
            <CourseCheckboxGroup courses={courseList.filter(course => course.is_buy === false)} onChange={setSelectedCourses} />
          </div>
        </div>
      )}
    </div>
  );
};

const CourseCheckboxGroup = ({ courses, onChange }) => {
  const [selectedIndexes, setSelectedIndexes] = useState([0]);
  useEffect(() => {
    onChange && onChange(selectedIndexes.map((index) => courses[index]))
  }, [selectedIndexes]);
  const handleClickCourse = (index) => {
    if (selectedIndexes.length === 1 && selectedIndexes[0] === index) {
      return;
    }
    if (selectedIndexes.some(i => i === index)) {
      setSelectedIndexes(selectedIndexes.reduce((next, i) => {
        if (i !== index) {
          next.push(i);
        }
        return next;
      }, []));
    } else {
      setSelectedIndexes(selectedIndexes.concat(index));
    }
  };
  return (
    <div className={styles['course-checkbox-group']}>
      {courses.map((course, index) => (
        <div key={index} className={classnames(styles.checkbox, selectedIndexes.some(i => i === index) && styles.checked)} onClick={() => handleClickCourse(index)}>
          {course.name}
        </div>
      ))}
    </div>
  );
};

export default MainSales;
